module.exports = __webpack_public_path__ + "static/media/Kalyani.814a2737.jpg";